import React from "react";
import "./rentability.css";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import styled from "styled-components";
import { texts } from "../../../../utils/texts";
import { RedirectWhatsappMain } from "../../../whatsapp/whatsapp";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}


function RentabilityTable10() {
  const table10 = [
    {
      Ano: "2014",
      Ibovespa: "-2.90%",
      Ouro: "12.04%",
      CDI: "10.77%",
      Poupança: "6.43%",
      Dólar: "13.39%",
    },
    {
      Ano: "2015",
      Ibovespa: "-13.30%",
      Ouro: "32.15%",
      CDI: "13.24%",
      Poupança: "7.29%",
      Dólar: "48.49%",
    },
    {
      Ano: "2016",
      Ibovespa: "38.90%",
      Ouro: "-12.32%",
      CDI: "14.00%",
      Poupança: "7.57%",
      Dólar: "-17.60%",
    },
    {
      Ano: "2017",
      Ibovespa: "26.90%",
      Ouro: "15.97%",
      CDI: "9.93%",
      Poupança: "6.61%",
      Dólar: "1.99%",
    },
    {
      Ano: "2018",
      Ibovespa: "15.00%",
      Ouro: "16.93%",
      CDI: "6.42%",
      Poupança: "4.62%",
      Dólar: "16.92%",
    },
    {
      Ano: "2019",
      Ibovespa: "31.60%",
      Ouro: "28.30%",
      CDI: "5.96%",
      Poupança: "4.30%",
      Dólar: "3.60%",
    },
    {
      Ano: "2020",
      Ibovespa: "2.92%",
      Ouro: "49.19%",
      CDI: "2.75%",
      Poupança: "2.11%",
      Dólar: "29.46%",
    },
    {
      Ano: "2021",
      Ibovespa: "-11.93%",
      Ouro: "4.43%",
      CDI: "4.35%",
      Poupança: "3.05%",
      Dólar: "7.39%",
    },
    {
      Ano: "2022",
      Ibovespa: "-4.69%",
      Ouro: "-0.19%",
      CDI: "13.65%",
      Poupança: "7.14%",
      Dólar: "-5.12%",
    },
    {
      Ano: "2023",
      Ibovespa: "22.28%",
      Ouro: "12.46%",
      CDI: "13.04%",
      Poupança: "7.42%",
      Dólar: "-8.21%",
    },
    {
      Ano: "2024",
      Ibovespa: "-10.36%",
      Ouro: "60.02%",
      CDI: "10.77%",
      Poupança: "7.06%",
      Dólar: "27.34%",
    },
  ];

  function navigate(message) {
    RedirectWhatsappMain(message);
  }
  return (
    <div className="overflow-auto">
      <table className="table table-hover table-bordered cTable mb-0">
        <thead>
          <tr>
            <th scope="col fw-bold text-white bg-success">Ano</th>
            <th scope="col fw-bold">Poupança</th>
            <th scope="col fw-bold">Ibovespa</th>
            <th scope="col fw-bold">CDI</th>
            <th scope="col fw-bold">Dólar</th>
            <th scope="col fw-bold">Ouro</th>
          </tr>
        </thead>
        <tbody>
          {table10.map((item, i) => (
            <tr key={i++}>
              <td>{item.Ano}</td>
              <td>{item.Poupança}</td>
              <td>{item.Ibovespa}</td>
              <td>{item.CDI}</td>
              <td>{item.Dólar}</td>
              <td>{item.Ouro}</td>
            </tr>
          ))}
        </tbody>
        <tfoot className=" fw-bold" style={{ background: "#D8D8D8" }}>
          <tr>
            <td>Total 10 anos</td>
            <td>63,60%</td>
            <td>94,42%</td>
            <td>104,88%</td>
            <td>117,65%</td>
            <td>218,98%</td>
          </tr>

          <tr key={100} style={{ background: "#F7F7F7" }}>
            <td colSpan={4}  style={{ border: "none", padding: 0, backgroundColor: '#F7F7F7' }}></td>
            <td className="td-buttons-rentabilidade ">
              <button className="button-chart" onClick={() => navigate(texts.cambio.whatsAppMessage.dolar)}>
              INVESTIR EM DÓLAR
              </button>
            </td>
            <td  className="td-buttons-rentabilidade "><button className="button-chart" onClick={() => navigate(texts.ouro.whatsAppMessage.default)}>
                {texts.ouro.buttons.default}
              </button></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default function Rentabilitys() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div id="rentability" className="mt-5">
      <div className="Alert-cont-h p-0">
        <h3>TABELA DE RENTABILIDADE</h3>
      </div>
      <Box
        sx={{
          flexGrow: 1,
          bgcolor: "#F7F7F7",
          border: "1px dotted grey",
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            className="tabRent"
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              className=" col-12 px-2 fw-bold"
              label="Aplicações financeiras nos últimos 10 anos"
              {...a11yProps(0)}
            />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <RentabilityTable10 />
        </TabPanel>
      </Box>
      <Legend>
        *Rentabilidade passada não representa rentabilidade futura.
      </Legend>
    </div>
  );
}
const Legend = styled.p`
  font-size: 14px;
  text-align: start;
  color: #010101;
`;
